export const cnpjValidation = value => {
  if (!value) return false

  const validTypes =
    typeof value === 'string' || Number.isInteger(value) || Array.isArray(value)

  if (!validTypes) return false

  const numbers = value
    .toString()
    .match(/\d/g)
    .map(Number)

  if (numbers.length !== 14) return false

  const items = [...new Set(numbers)]
  if (items.length === 1) return false

  const calc = x => {
    const slice = numbers.slice(0, x)
    let factor = x - 7
    let sum = 0

    for (let i = x; i >= 1; i--) {
      const n = slice[x - i]
      sum += n * factor--
      if (factor < 2) factor = 9
    }

    const result = 11 - (sum % 11)

    return result > 9 ? 0 : result
  }

  const digits = numbers.slice(12)

  const digit0 = calc(12)
  if (digit0 !== digits[0]) return false

  const digit1 = calc(13)
  return digit1 === digits[1]
}

export const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

// Gotten from https://stackoverflow.com/questions/52882658/regex-for-brazilian-phone-number
const BRAZILIAN_PHONE_REGEX = /^\s*(\d{2})[-. ]?(\d{5}|\d{4})[-. ]?(\d{4})[-. ]?\s*$/
export const validatePhone = phoneString => {
  const phoneOnlyNumbers = phoneString.replace(/\D/g, '')
  return BRAZILIAN_PHONE_REGEX.test(String(phoneOnlyNumbers))
}

export const formatCurrencyToReal = value =>
  value
    .toString()
    .replace(/\D/g, '')
    .replace(/(\d)(\d{8})$/, '$1.$2')
    .replace(/(\d)(\d{5})$/, '$1.$2')
    .replace(/(\d)(\d{2})$/, '$1,$2')

export const convertCurrencyToFloat = value => {
  if (value === '') {
    value = 0
  } else {
    value = value.replace('.', '')
    value = value.replace(',', '.')
    value = parseFloat(value)
  }
  return value
}
